module.exports = __webpack_public_path__ + "img/wrw.124d8cb9.png";